import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject)
  }

  const result = originalPush.call(this, location)

  if (result && typeof result.catch === 'function') {
    return result.catch(err => err)
  }

  return result
}

const originalReplace = Router.prototype.replace
Router.prototype.replace = function replace (location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalReplace.call(this, location, onResolve, onReject)
  }

  const result = originalReplace.call(this, location)

  if (result && typeof result.catch === 'function') {
    return result.catch(err => err)
  }

  return result
}

// 公共路由，无需权限
export const publicRouterMap = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/Login')
  },
  {
    path: '/',
    name: 'Index',
    component: () => import('@/views/Layout'),
    meta: {
      title: '智慧病理云后台管理系统'
    }
  },
  {
    path: '/printing',
    name: 'printing',
    component: () => import('@/views/esophagus/components/ProductCodePrint')
  },
  {
    path: '/casereport',
    name: 'CaseReport',
    component: () => import('@/views/casereport/CaseReportList'),
    meta: {
      title: '报告查询'
    }
  }
]

// 初始只挂载公共路由，其他有后台传递进行渲染
export default new Router({
  // 跳转url没有#号
  mode: 'history',
  routes: publicRouterMap
})



// WEBPACK FOOTER //
// ./src/router/index.js